import React, { memo, useEffect, useState } from 'react'
import { Form, Formik, Field, ErrorMessage, } from 'formik'
import * as Yup from 'yup'
import TextError from '../TextError';
import { PaymentMode } from '../../utils/paymentMode';
import { Select, Spin } from 'antd';
import { updatebookinghistorytabvalue, updatenotificationdata } from '../../store/Common/CommonSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { offlinePaymentDetails } from '../../store/OfflinePayement/OfflinePaymentSlice';
import Bookingintermediatrypage from '../../components/common/PaymentSection/BookingIntermediatrypage';
import { ToastContainer, toast } from "react-toastify";
import {
  getsinglebookingdata,
} from "../../store/BookingHistory/BookingHistorySlice";
import "react-toastify/dist/ReactToastify.css";

const ManualPaymentForm = ({nodeData,props, queryId,setBookingType,setOpen1, open1,selectedItem, paymentId,remainingBalance,useCreditAmount}) => {
   console.log("nodeData",nodeData,props)
console.log("queryId",queryId);
    const [spinner, setSpinner] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
     const [singlebookingdata,setsinglebookingdata]=useState();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    //  console.log("open1mpf",open1)
    useEffect(() => {
         dispatch (getsinglebookingdata({queryId:queryId})) .then((res) => {
              setsinglebookingdata(res?.payload?.data?.data);
           
            })
            .catch((err) => {
              console.error(err);
            });
    },[])
    
    const queryidofflinepayment={
        paymentmode: 'offline',
        queryId: queryId
    }
    const onSubmit = (values,setprops)=>{
        const newdata ={...nodeData?.searchquery, ...props?.searchquery}
        console.log("values",newdata)
        setSpinner(true)
        values.searchQueryData = newdata
        values.carrierType = nodeData?.searchquery?.cargoType;
        values.bookedItem = selectedItem;
        values.queryId = queryId;
        values.bookingAmount = remainingBalance;
        values.paymentId = paymentId;
        values.useCreditAmount = useCreditAmount;
        dispatch(offlinePaymentDetails(values))
        .then((res)=>{
            setSpinner(false)
            dispatch(updatenotificationdata(res?.payload?.data))
            // console.log("res",res)
            if(res?.payload?.data.statusCode === 200){
                nodeData?.searchquery?.cargoType === 'Air Cargo' ? dispatch(updatebookinghistorytabvalue(1)) : dispatch(updatebookinghistorytabvalue(2))
                setIsModalOpen(true);
                // navigate('/booking-history')
            }else if(res?.payload?.data.statusCode === 409){
                toast.error(res?.payload?.data.message , {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    // theme: "colored",
                  });    
            }
        })
        .catch(err=>{
            console.log(err)
            toast.error(err , {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                // theme: "colored",
              });
      
        })
    }
    const initialValues = {
        paymentmode: '',
        UTRnumber: '',
    }
    const validationSchema = Yup.object().shape({
        paymentmode: Yup.string().required('Mode of Payment is required'),
        UTRnumber: Yup.string().required('UTR Number is required')
    })
    const inputchange = (e,field,form)=>{
        e.preventDefault();
        const { value } = e.target;
        const regex = /^[0-9a-zA-Z&]*$/;
        if (regex.test(value.toString())) {
            form.setFieldValue(field, value);
        }else if(value === ''){
            form.setFieldValue(field, value);
        }
    }
    return (
        <>
          <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        >
            {
                formik =>{
                    return(
                        <>
                          <ToastContainer />
                          <Form autoComplete='off'>
                            <div className="bg-whites w-full">
                                <div className="grid grid-cols-6 gap-6 items-end">
                                    <div className="col-span-6">
                                        <label htmlFor='paymentmode' className="py-2 block text-xs font-semibold leading-5 text-formlabel">Mode of Payment2*</label>
                                        <Field component={SelectField} name='paymentmode' selectOptions={PaymentMode} placeholder='Select Mode' />
                                        <ErrorMessage name='paymentmode' component={TextError}/>
                                    </div>
                                    <div className="col-span-6">
                                        <label htmlFor='password' className="py-2 block text-xs font-semibold leading-5 text-formlabel">Enter UTR/Cheque Number2*</label>
                                        <Field type='text' id='UTRnumber' name='UTRnumber' placeholder="Enter UTR Number" onChange={(e)=>inputchange(e,'UTRnumber',formik)} className="leading-4 px-4 py-3 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md disabled:bg-white"/>
                                        <ErrorMessage name='UTRnumber' component={TextError}/>
                                    </div>                                        
                                    <div className="col-span-6">
                                        <button type='submit' className='w-full text-white bg-primary py-3 rounded-md px-5 text-sm font-bold hover:bg-secondary shadow-loginbutton mt-3' disabled={spinner}>
                                            {
                                                spinner ?
                                                    <Spin/>
                                                :
                                                    'Submit'
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                        </>

                    )
                }
            }
        </Formik>
        <Bookingintermediatrypage
        isOpen={isModalOpen}
        onClose={() =>navigate("/search-rates")}//setBookingType("")&& setIsModalOpen(false)&& setOpen1(false)
        selectedItem={selectedItem}
        queryidofflinepayment={queryidofflinepayment}
        props={props}
        nodeData1={nodeData}
        title="Booking Confirmation"
        onConfirm={() => navigate("/booking-history")}
      />
        </>
      
        
    )
}
const SelectField = memo(({field,placeholder,selectOptions,form,})=>{
    const handleChange = (value) => {
        form.setFieldValue(field.name, value);
    };
    return(
        <>
            <Select
            //value={form.values.paymentmode}
            onChange= {handleChange}
            id={field.name} 
            name={field.name}
            className="py-1 leading-6 text-[#757575] focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md"
            bordered={false}
            placeholder= 'Select Mode'
            optionFilterProp="children"
            options={selectOptions}
            dropdownStyle={{zIndex:9999}}
            style={{color:'red'}}
            />
        </>
    )
})
export default React.memo(ManualPaymentForm)